"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
exports.focusOnFirstError = focusOnFirstError;
exports.getFirstMessageError = getFirstMessageError;
exports.getFirstMessageErrorFromMultiForm = getFirstMessageErrorFromMultiForm;
exports.getFocusableElement = getFocusableElement;
exports.getText = getText;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Button = require("../../elements/button/Button");
var _errorConstants = _interopRequireDefault(require("../../constants/errorConstants"));
var _scrollTo = require("../../utils/scroll/scrollTo");
var _formErrorSummaryLinkModule = _interopRequireDefault(require("./form-error-summary-link.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function getText(totalValidationErrors) {
  return totalValidationErrors > 1 ? 'Go to first error' : 'Go to error';
}
function getFirstMessageError(parentForm) {
  if (parentForm) {
    return parentForm.querySelector("[data-test=\"".concat(_errorConstants["default"].DATA_TEST_ERROR, "\"]"));
  }
  return undefined;
}
function getFirstMessageErrorFromMultiForm() {
  return document.querySelector("[data-test=\"".concat(_errorConstants["default"].DATA_TEST_ERROR, "\"]"));
}
function getFocusableElement(parentForm, forValue) {
  return parentForm.querySelector("#".concat(forValue));
}
function getParentForm(el) {
  if (el && el.parentNode) {
    var parent = el.parentNode;
    if (parent && parent.tagName !== 'FORM') {
      parent = getParentForm(parent);
    }
    return parent;
  }
  return undefined;
}
function focusOnFirstError(evt, multiFormValidation) {
  var parentForm = getParentForm(evt.target);
  var firstMessageError = getFirstMessageError(parentForm);
  if (!firstMessageError && multiFormValidation) {
    var errorFieldOutsideOfParentForm = getFirstMessageErrorFromMultiForm();
    parentForm = getParentForm(errorFieldOutsideOfParentForm);
    firstMessageError = getFirstMessageError(parentForm);
  }
  if (firstMessageError) {
    var forValue = firstMessageError.getAttribute('for');
    var firstErroringFormField = getFocusableElement(parentForm, forValue);
    if (firstErroringFormField) {
      (0, _scrollTo.scrollToElement)(firstErroringFormField, true);
    } else {
      (0, _scrollTo.scrollToElement)(firstMessageError, true);
    }
  }
}
var FormErrorSummaryLink = function FormErrorSummaryLink(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.UnderlinedButton, {
    className: (0, _classnames["default"])(_defineProperty({}, _formErrorSummaryLinkModule["default"].hiddenLink, props.hideFirstErrorLink)),
    onClick: function onClick(evt) {
      return focusOnFirstError(evt, props.multiFormValidation);
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      children: getText(props.totalValidationErrors)
    })
  });
};
FormErrorSummaryLink.propTypes = {
  totalValidationErrors: _propTypes["default"].number,
  hideFirstErrorLink: _propTypes["default"].bool,
  multiFormValidation: _propTypes["default"].bool
};
FormErrorSummaryLink.defaultProps = {
  totalValidationErrors: 0,
  hideFirstErrorLink: false,
  multiFormValidation: false
};
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(FormErrorSummaryLink);